import { RootState } from "../reducers"

export const getPartnerExperience = (state: RootState) => state?.commonBenefits?.experience || state?.partnerDetails?.partnerDetails?.experience;